import {
  ComputerIcon,
  GearIcon,
  HierarchyIcon,
  GroupIcon,
  DataIcon,
  DocumentIcon,
  TrophyIcon,
  CalendarIcon,
} from "../components/icons";

/** 
 * @typedef {{ id: string, label: string, path: string, icon: React.ComponentType<any> }} TabItem 
 */

/** @type {TabItem[]} */
export const organizationTabs = [
  {
    id: "overview",
    label: "Resumen",
    path: "/organization",
    icon: ComputerIcon,
  },
  {
    id: "roles",
    label: "Roles",
    path: "/organization/roles",
    icon: TrophyIcon,
  },
  {
    id: "departments",
    label: "Departamentos",
    path: "/organization/departments",
    icon: HierarchyIcon,
  },
  {
    id: "members",
    label: "Miembros",
    path: "/organization/members",
    icon: GroupIcon,
  },
  {
    id: "org-chart",
    label: "Organigrama",
    path: "/organization/org-chart",
    icon: DataIcon,
  },
];

/** @type {TabItem[]} */
export const questionBankTabs = [
  {
    id: "overview",
    label: "Resumen",
    path: "/question-bank",
    icon: ComputerIcon,
  },
  {
    id: "categories",
    label: "Categorías",
    path: "/question-bank/categories",
    icon: DocumentIcon,
  },
  {
    id: "subcategories",
    label: "Subcategorías",
    path: "/question-bank/subcategories",
    icon: DocumentIcon,
  },
  {
    id: "questions",
    label: "Preguntas",
    path: "/question-bank/questions",
    icon: CalendarIcon,
  },
];

/** @type {TabItem[]} */
export const questionnaireTabs = [
  {
    id: "overview",
    label: "Resumen",
    path: "/questionnaire",
    icon: ComputerIcon,
  },
  {
    id: "all",
    label: "Todos",
    path: "/questionnaire/all",
    icon: DocumentIcon,
  },
  {
    id: "responses",
    label: "Respuestas",
    path: "/questionnaire/responses",
    icon: DataIcon,
  },
  {
    id: "settings",
    label: "Configuración",
    path: "/questionnaire/settings",
    icon: GearIcon,
  },
];
